import { calculateMarcoFijo, calculateVidriosMarcoFijo } from './ventanaTypes/marcoFijo';
import { calculateMonorielAmericano, calculateVidriosMonorielAmericano } from './ventanaTypes/monorielAmericano';
import { calculateCorrederaChica, calculateVidriosCorrederaChica } from './ventanaTypes/correderaChica';
import { calculateCorrederaGrande, calculateVidriosCorrederaGrande } from './ventanaTypes/correderaGrande';
import { calculateProyectanteExterior, calculateVidriosProyectanteExterior } from './ventanaTypes/proyectanteExterior';
import { calculatePuertaExterior, calculateVidriosPuertaExterior } from './ventanaTypes/puertaExterior';
import { calculateProyectanteFijo, calculateVidriosProyectanteFijo } from './ventanaTypes/proyectanteFijo';
import { calculateDoblerielAmericano, calculateVidriosDoblerielAmericano } from './ventanaTypes/doblerielAmericano';

export const calculateElements = (type, width, height, additionalMeasure) => {
  console.log('calculateElements recibió:', { type, width, height, additionalMeasure });

  switch (type) {
    case 'proyectanteFijo':
      return calculateProyectanteFijo(width, height, additionalMeasure);
    case 'marcoFijo':
      return calculateMarcoFijo(width, height);
    case 'monorielAmericano':
      return calculateMonorielAmericano(width, height);
    case 'correderaChica':
      return calculateCorrederaChica(width, height);
    case 'correderaGrande':
      return calculateCorrederaGrande(width, height);
    case 'proyectanteExterior':
      return calculateProyectanteExterior(width, height);
    case 'puertaExterior':
      return calculatePuertaExterior(width, height);
    case 'doblerielAmericano':
      return calculateDoblerielAmericano(width, height);
    default:
      return null;
  }
};

export const calculateVidrios = (type, height, width, additionalMeasure) => {
  console.log('calculateVidrios llamado con:', { type, height, width, additionalMeasure });

  switch (type.toLowerCase()) {
    case 'monorielamericano':
      return calculateVidriosMonorielAmericano(height, width);
    case 'proyectantefijo':
      return calculateVidriosProyectanteFijo(height, width,additionalMeasure);
    case 'doblerielamericano':
      return calculateVidriosDoblerielAmericano(height, width);
    case 'marcofijo':
      return calculateVidriosMarcoFijo(height, width);
    case 'correderachica':
      return calculateVidriosCorrederaChica(height, width);
    case 'correderagrande':
      return calculateVidriosCorrederaGrande(width, height);
    case 'puertaexterior':
      return calculateVidriosPuertaExterior(height, width);
    case 'proyectanteexterior':
      return calculateVidriosProyectanteExterior(height, width);
    default:
      return null;
  }
};
